var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandHoldingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.334,
    viewBox: "0 0 24 21.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hand-holding-medical-solid",
    d: "M9.333,1V3.333H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9.333V9.667a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V7.333h2.333a1,1,0,0,0,1-1v-2a1,1,0,0,0-1-1H13.333V1a1,1,0,0,0-1-1h-2A1,1,0,0,0,9.333,1ZM23.321,16.342a1.666,1.666,0,0,0-1.975-2.683l-4.988,3.675H11.333a.667.667,0,0,1,0-1.333h3.333a1.333,1.333,0,0,0,0-2.667h-6.6A5.347,5.347,0,0,0,4.738,14.5L2.867,16H1.333A1.332,1.332,0,0,0,0,17.334V20a1.332,1.332,0,0,0,1.333,1.333H14.688a5.681,5.681,0,0,0,3.363-1.1l5.275-3.888ZM8.029,16h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHoldingIcon);
export default __webpack_public_path__ + "static/media/handHoldingIcon.fd806c443159bea82473a0ba6176be83.svg";
export { ForwardRef as ReactComponent };